<template>
  <div data-component-group="businesses-dialog" data-component="add-new">
    <dialog-add
      icon="business_center"
      :title="$t('create_business')"
      content-class="add-business-dialog"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-businesses-add-new
          :item="emptyBusiness"
          class="elevation-1"
          :is-loading="isAddingBusiness"
          :on-cancel="onCancel"
          :on-submit="createBusiness"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isAddingBusiness: false,
        emptyBusiness: {},
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'businesses' });
      },
      createBusiness(business) {
        this.isAddingBusiness = true;

        return this.$store
          .dispatch('businesses/create', business)
          .then((res) => {
            this.$router.push({ name: 'businesses', query: { status: 'success' } });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isAddingBusiness = false;
          });
      },
    },
  };
</script>

<style lang="scss">
.add-business-dialog > .modal__backdrop > .modal__content > .modal__body > * {
  padding: 0;
}
</style>
